var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.739 272.696C484.174 272.696 478.609 270.47 474.156 266.574L256 53.4265L37.8434 266.574C28.9391 274.922 15.026 274.922 6.1217 266.018C-2.22613 257.114 -2.22613 243.2 6.67822 234.296L240.417 6.1222C249.322 -2.22563 262.678 -2.22563 271.583 6.1222L505.322 234.296C514.226 242.644 514.226 257.114 505.878 266.018C501.426 270.47 495.304 272.696 489.739 272.696ZM440.765 489.74V272.14C440.765 259.896 430.748 249.879 418.504 249.879C406.261 249.879 396.243 259.896 396.243 272.14V467.479H326.678V348.383C326.678 332.244 313.322 318.887 297.183 318.887H214.817C198.678 318.887 185.322 332.244 185.322 348.383V467.479H115.756V272.14C115.756 259.896 105.739 249.879 93.4956 249.879C81.2521 249.879 71.2347 259.896 71.2347 272.14V489.74C71.2347 501.983 81.2521 512 93.4956 512H207.583C219.826 512 229.843 501.983 229.843 489.74V363.409H282.713V489.74C282.713 501.983 292.73 512 304.974 512H419.061C431.304 512 440.765 501.983 440.765 489.74Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 612,
    height: 612,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.0e28b6e5e99e530c65707d531579979f.svg";
export { ForwardRef as ReactComponent };